import { combineReducers } from '@reduxjs/toolkit';

import { sessionsApi } from '../actions/sessions';

// No slice reducers in this feature yet — placeholder keeps combineReducers valid
const placeholder = (state = {}) => state;

export default combineReducers({ placeholder });

export const roreApis = [sessionsApi] as const;
